import React, { useEffect, useState } from 'react';
import { FaTerminal, FaCode, FaBrain, FaServer, FaDatabase, FaShieldAlt, FaCloud } from 'react-icons/fa';
import WOW from 'wowjs';
import './Skills.css';

export default function Skills() {
  const [currentDirectory] = useState("~/skills");

  useEffect(() => {
    new WOW.WOW().init();
  }, []);

  const skillCategories = {
    'Core Computer Science': [
      { name: 'Data Structures', icon: 'https://cdn-icons-png.flaticon.com/512/2103/2103633.png' },
      { name: 'Algorithms', icon: 'https://cdn-icons-png.flaticon.com/512/7017/7017474.png' },
      { name: 'System Design', icon: 'https://cdn-icons-png.flaticon.com/512/1935/1935179.png' },
      { name: 'Design Patterns', icon: 'https://cdn-icons-png.flaticon.com/512/3079/3079165.png' },
      { name: 'Computer Networks', icon: 'https://cdn-icons-png.flaticon.com/512/2885/2885417.png' },
      { name: 'Operating Systems', icon: 'https://cdn-icons-png.flaticon.com/512/2921/2921222.png' },
    ],
    'Languages & Low-Level': [
      { name: 'C++', icon: 'https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg' },
      { name: 'Python', icon: 'https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg' },
      { name: 'Go', icon: 'https://upload.wikimedia.org/wikipedia/commons/0/05/Go_Logo_Blue.svg' },
      { name: 'Assembly', icon: 'https://cdn-icons-png.flaticon.com/512/1785/1785210.png' },
      { name: 'MOJO', icon: 'https://cdn.prod.website-files.com/63f9f100025c058594957cca/65df9332b319cb9989698874_mojo.jpg' },
      { name: 'Rust', icon: 'https://upload.wikimedia.org/wikipedia/commons/d/d5/Rust_programming_language_black_logo.svg' },
    ],
    'AI & Algorithms': [
      { name: 'Machine Learning', icon: 'https://cdn-icons-png.flaticon.com/512/2103/2103832.png' },
      { name: 'PyTorch', icon: 'https://upload.wikimedia.org/wikipedia/commons/1/10/PyTorch_logo_icon.svg' },
      { name: 'TensorFlow', icon: 'https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg' },
      { name: 'NLP', icon: 'https://cdn-icons-png.flaticon.com/512/2103/2103992.png' },
      { name: 'Computer Vision', icon: 'https://cdn-icons-png.flaticon.com/512/1693/1693746.png' },
      { name: 'Reinforcement Learning', icon: 'https://cdn-icons-png.flaticon.com/512/2103/2103833.png' },
    ],
    'Backend & Systems': [
      { name: 'Distributed Systems', icon: 'https://cdn-icons-png.flaticon.com/512/6729/6729674.png' },
      { name: 'Microservices', icon: 'https://cdn-icons-png.flaticon.com/512/8099/8099237.png' },
      { name: 'System Architecture', icon: 'https://cdn-icons-png.flaticon.com/512/1998/1998087.png' },
      { name: 'NodeJS', icon: 'https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg' },
      { name: 'gRPC', icon: 'https://grpc.io/img/logos/grpc-icon-color.png' },
      { name: 'GraphQL', icon: 'https://upload.wikimedia.org/wikipedia/commons/1/17/GraphQL_Logo.svg' },
    ],
    'Data Engineering': [
      { name: 'Apache Kafka', icon: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTDCsnH-LecjXUO0ujaEgMSALxOVGEf_7KSZA&s' },
      { name: 'Apache Spark', icon: 'https://upload.wikimedia.org/wikipedia/commons/f/f3/Apache_Spark_logo.svg' },
      { name: 'Hadoop', icon: 'https://upload.wikimedia.org/wikipedia/commons/0/0e/Hadoop_logo.svg' },
      { name: 'ETL Pipelines', icon: 'https://cdn-icons-png.flaticon.com/512/4233/4233830.png' },
      { name: 'Data Warehousing', icon: 'https://cdn-icons-png.flaticon.com/512/2906/2906274.png' },
      { name: 'Stream Processing', icon: 'https://cdn-icons-png.flaticon.com/512/1185/1185544.png' },
    ],
    'Infrastructure & DevOps': [
      { name: 'Docker', icon: 'https://upload.wikimedia.org/wikipedia/commons/4/4e/Docker_%28container_engine%29_logo.svg' },
      { name: 'Kubernetes', icon: 'https://upload.wikimedia.org/wikipedia/commons/3/39/Kubernetes_logo_without_workmark.svg' },
      { name: 'CI/CD', icon: 'https://cdn-icons-png.flaticon.com/512/8649/8649595.png' },
      { name: 'Infrastructure as Code', icon: 'https://cdn-icons-png.flaticon.com/512/6357/6357048.png' },
      { name: 'Cloud Architecture', icon: 'https://cdn-icons-png.flaticon.com/512/4413/4413573.png' },
      { name: 'Monitoring & Logging', icon: 'https://cdn-icons-png.flaticon.com/512/1150/1150754.png' },
    ],
    'Security & Networking': [
      { name: 'Cryptography', icon: 'https://cdn-icons-png.flaticon.com/512/2092/2092663.png' },
      { name: 'Network Security', icon: 'https://cdn-icons-png.flaticon.com/512/2885/2885417.png' },
      { name: 'OAuth/JWT', icon: 'https://cdn-icons-png.flaticon.com/512/6195/6195699.png' },
      { name: 'SSL/TLS', icon: 'https://cdn-icons-png.flaticon.com/512/2889/2889676.png' },
      { name: 'Firewall Configuration', icon: 'https://cdn-icons-png.flaticon.com/512/2716/2716652.png' },
      { name: 'Penetration Testing', icon: 'https://cdn-icons-png.flaticon.com/512/2716/2716674.png' },
    ],
  };

  const categoryIcons = {
    'Core Computer Science': FaCode,
    'Languages & Low-Level': FaTerminal,
    'AI & Algorithms': FaBrain,
    'Backend & Systems': FaServer,
    'Data Engineering': FaDatabase,
    'Infrastructure & DevOps': FaCloud,
    'Security & Networking': FaShieldAlt,
  };

  return (
    <section id="skills" className="skills-section">
      <div className="terminal-window">
        <div className="terminal-bar">
          <div className="terminal-buttons">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="terminal-title">
            <FaTerminal /> skills.sh — {currentDirectory}
          </div>
        </div>
        <div className="terminal-content">
          <div className="command-line">
            <span className="prompt">$</span>
            <span className="directory">{currentDirectory}</span>
            <span className="command">ls -la ./skills/</span>
          </div>
          <div className="skills-container">
            {Object.entries(skillCategories).map(([category, skills], categoryIndex) => {
              const CategoryIcon = categoryIcons[category];
              return (
                <div key={category} className="skill-category wow fadeInUp" data-wow-delay={`${0.1 * (categoryIndex + 1)}s`}>
                  <h2>
                    {CategoryIcon && <CategoryIcon />}
                    {category}
                  </h2>
                  <div className="skills-grid">
                    {skills.map((skill, index) => (
                      <div key={`${skill.name}-${index}`} className="skill-item">
                        <div className="skill-icon-wrapper">
                          <img src={skill.icon} alt={skill.name} className="skill-icon" />
                        </div>
                        <p>{skill.name}</p>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="command-line">
            <span className="prompt">$</span>
            <span className="directory">{currentDirectory}</span>
            <span className="cursor">|</span>
          </div>
        </div>
      </div>
    </section>
  );
}